import ExpandMore from "@mui/icons-material/ExpandMore";
import HeadsetMicOutlined from "@mui/icons-material/HeadsetMicOutlined";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import PersonOutline from "@mui/icons-material/PersonOutline";
import SettingsOutlined from "@mui/icons-material/SettingsOutlined";
import { Box, ButtonBase, Typography } from "@mui/material";
import React from "react";

export const themePillarStyles: Record<
  string,
  { color: string; background: string; icon: React.ElementType; order: number }
> = {
  Deployability: { color: "#0F8B6D", background: "#E8F7F2", icon: SettingsOutlined, order: 0 },
  Usability: { color: "#0F6CBD", background: "#EAF4FF", icon: PersonOutline, order: 1 },
  Supportability: { color: "#6B3FB5", background: "#F2ECFC", icon: HeadsetMicOutlined, order: 2 },
  Other: { color: "#49627B", background: "#F3F5F7", icon: InfoOutlined, order: 3 }
};

type ThemePillarHeaderProps = {
  pillar: string;
  themeCount: number;
  studyCount: number;
  expanded: boolean;
  controlsId: string;
  onToggle: () => void;
};

const ThemePillarHeader: React.FC<ThemePillarHeaderProps> = ({
  pillar,
  themeCount,
  studyCount,
  expanded,
  controlsId,
  onToggle
}) => {
  const style = themePillarStyles[pillar] ?? themePillarStyles.Other;
  const PillarIcon = style.icon;

  return (
    <ButtonBase
      aria-expanded={expanded}
      aria-controls={controlsId}
      onClick={onToggle}
      sx={{
        width: "100%",
        px: 1.5,
        py: 0.9,
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: 1.5,
        textAlign: "left",
        bgcolor: pillar === "Deployability" ? "#DFF7EE" : style.background,
        "&:focus-visible": { outline: `2px solid ${style.color}`, outlineOffset: -2 }
      }}
    >
      <Box
        sx={{
          width: 30,
          height: 30,
          display: "grid",
          placeItems: "center",
          flexShrink: 0,
          borderRadius: "6px",
          color: "#FFF",
          bgcolor: style.color
        }}
      >
        <PillarIcon sx={{ fontSize: 21 }} />
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 1, minWidth: 0 }}>
        <Typography sx={{ color: "#091F3A", fontSize: 13, fontWeight: 800 }}>{pillar}</Typography>
        <Typography sx={{ color: "#091F3A", fontSize: 12, lineHeight: "normal", whiteSpace: "nowrap" }}>
          {themeCount} {themeCount === 1 ? "theme" : "themes"}
          {" \u2022 "}
          {studyCount} {studyCount === 1 ? "study" : "studies"}
        </Typography>
      </Box>
      {expanded ? (
        <ExpandMore sx={{ ml: "auto", color: style.color, fontSize: 22, flexShrink: 0 }} />
      ) : (
        <KeyboardArrowRight sx={{ ml: "auto", color: style.color, fontSize: 22, flexShrink: 0 }} />
      )}
    </ButtonBase>
  );
};

export default ThemePillarHeader;
